export default {"src":"/_next/static/media/hubspot.8662648e.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};